import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=ba22f8f8&scoped=true"
import script from "./EventListItem.vue?vue&type=script&lang=js"
export * from "./EventListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba22f8f8",
  null
  
)

export default component.exports